const getMessages=(data)=>{

    let{response}=data;
    let{data:resData}=response;
    let{resourceKeyResult}=resData
    let{resourceKeyList}=resourceKeyResult
    let messages=resourceKeyList.map(({resourceKeys})=>{
    return resourceKeys
    })
    let errors = messages.map(innerArray => innerArray[0]);
    // console.log(result2);
    return errors
    // return messages



}


export {
    getMessages
}





// function getFileExtension(filename) {
//     // Find the position of the last dot in the filename
// if (filename) {
//   const dotIndex = filename.lastIndexOf('.');
    
//   // Check if a dot exists in the filename and return the substring after the dot
//   if (dotIndex !== -1) {
//     return filename.substring(dotIndex + 1);
//   } else {
//     return 'No extension found';
//   }
// }
//   }


//   export{
//     getFileExtension
//   }